module.exports = __webpack_public_path__ + "img/2.0b14d5c9.webp";